const adminDashboardReducer = (state = null, action) => {
    switch (action.type) {
        case "UPDATE_ADMIN_DASHBOARD":
            state = action.payload;
            return state;
        case "CLEAR_ADMIN_DASHBOARD":
            return null;
        default:
            return state;
    }
}

export default adminDashboardReducer;